import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const employeeEntity: Entity = {
  model: model,
  repository: repository,
}

export default employeeEntity
